import styled from '@themes/theme'

export const ChargingCompleteWrap = styled.div`
  z-index: 1;
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  top: 50%;
  transform: translateY(-50%);
  .txt-wrap {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 18px;
    .txt-01 {
      font-size: ${props => props.theme.font.large};
    }
    .txt-02 {
      font-size: ${props => props.theme.font.largeNum};
    }
  }
  .go-shop-btn {
    width: 180px;
    height: 38px;
    margin-top: 15px;
    background: ${props => props.theme.color.modalOrange};
  }
`
